module.exports = __webpack_public_path__ + "static/media/plugin-sort-asc.881aaecd.svg";